import { ERROR_CODES } from '@/consts';

export default class InvalidNewPassword extends Error {
  static code = ERROR_CODES.AUTH_NEW_PASSWORD_IS_THE_SAME_CURRENT_PASSWORD;

  constructor(message) {
    super(message || 'New password is the same with Current password.');
    this.code = ERROR_CODES.AUTH_NEW_PASSWORD_IS_THE_SAME_CURRENT_PASSWORD;
  }
}
